<template>
  <div class="announcement-outer">
    <BlockTitle title="成交公告"/>
    <div class="table-outer">
      <div class="table-head">
        <div class="cell">项目名称</div>
        <div class="cell">成交价格</div>
        <div class="cell">成交时间</div>
      </div>
      <div class="table-body" >
        <SeamlessScroll
          :list="announcementList"
        >
          <template v-slot:scrollInner="{item,index}">
            <div :class="`row ${isEven(index + 1) ? 'zebra':''}`" >
              <div class="cell" :title="item.title">{{item.title}}</div>
              <div class="cell" :title="item.price">{{item.price}}</div>
              <div class="cell" :title="item.makeAt">{{item.makeAt}}</div>
            </div>
          </template>
        </SeamlessScroll>
      </div>
    </div>
  </div>
</template>

<script>
import BlockTitle from '@/views/public_0983cc/tradeData/components/public/BlockTitle.vue'
import SeamlessScroll from '@/components/base/SeamlessScroll.vue'
import { mapGetters } from 'vuex'

import {
  data_v2_notice,
} from '@/api/portal'

export default {
  components:{
    BlockTitle,
    SeamlessScroll
  },
  data(){
    return {
      announcementList:[],
    }
  },
  computed:{
    ...mapGetters(['selectLocId']),
    isEven(){
      return function(index){
        return index % 2 === 0
      }
    },
  },
  watch:{
    selectLocId(){
      this.getAnnouncement()
    }
  },
  created(){
    this.getAnnouncement()
  },
  mounted(){
  },
  methods:{
    // 获取公共
    async getAnnouncement(){
      let {data} = await data_v2_notice({locId:this.selectLocId,rows:20})
      this.announcementList = data
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep{
  .block-title-outer .title{
    height: auto;
  }
}
.announcement-outer{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.table-outer{
  height: 100%;
  color: #fff;
  .cell{
    height: 40px;
    line-height: 40px;
    padding: 0 10px;
  }
  .table-head{
    display: flex;
    justify-content: space-between;
    color: rgba($color: #fff, $alpha: .9);
    font-size: 16px;
    padding-bottom: 7px;
    margin: 10px 0 7px 0;
    border-bottom: 2px solid #00468A;
    .cell{
      flex: 1;
      text-align: center;
    }
  }
  .table-body{
    overflow: hidden;
    height: 215px;
    .row{
      display: flex;
      justify-content: space-between;
      align-items: center;
      .cell{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        flex: 1;
        text-align: center;
        &:first-child{
          text-align: left;
        }
      }
      &.zebra{
        background-color: #00468A;
      }

    }
  }
}
</style>